import React, { forwardRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Close from '@material-ui/icons/Close';
import Warning from 'assets/img/ic_msg_warning.svg';
import Success from 'assets/img/ic_msg_success.svg';
import SuccessIcon from 'assets/img/icons/success.svg';
import ErrorIcon from 'assets/img/icons/error.svg';
import Button from 'components/CustomButtons/Button';
import styles from 'assets/jss/material-dashboard-pro-react/components/customConfirmationDialogStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { SlideProps } from '@material-ui/core/Slide/Slide';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

const Transition = forwardRef(function Transition(props: SlideProps, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

export interface IConfirmationDialogButton {
	name: string;
	onClick: (event: React.FormEvent<HTMLInputElement>) => void;
	color: types.theme.buttonColor;
	className?: string;
}

interface IConfirmationDialogProps {
	isOpen: boolean;
	isError?: boolean;
	hideDialog: () => void;
	button?: IConfirmationDialogButton;
	header?: React.ReactElement;
	children?: React.ReactElement;
	withoutIcon?: boolean;
	noMargin?: boolean;
	width?: number;
	padding?: string;
	withoutCloseButton?: boolean;
	isNewDashBoardEnabled?: boolean;
}

const CustomConfirmationDialog = ({
	isOpen,
	isError,
	hideDialog,
	button,
	header,
	children,
	withoutIcon,
	width,
	padding,
	noMargin = false,
	withoutCloseButton,
	isNewDashBoardEnabled,
}: IConfirmationDialogProps) => {
	const classes = useStyles({ width, padding, isNewDashBoardEnabled });
	const successIcon = isNewDashBoardEnabled ? SuccessIcon : Success;
	const errorIcon = isNewDashBoardEnabled ? ErrorIcon : Warning;
	return (
		<Dialog
			// @ts-ignore
			open={isOpen}
			// @ts-ignore
			TransitionComponent={Transition}
			keepMounted
			onClose={hideDialog}
			className={classes.dialog}
		>
			<>
				<ConditionalRender
					show={!!withoutCloseButton}
					onFalse={() => (
						<button className={classes.dialogCloseButton} onClick={hideDialog} autoFocus>
							<Close />
						</button>
					)}
				/>
				<div className={classes.bodyWrapper} data-testid="confirmation-dialog-body">
					<div
						className={classNames(classes.iconWrapper, {
							[classes.withoutIcon]: withoutIcon || noMargin,
						})}
					>
						{!isError && !withoutIcon && <img src={successIcon} alt="" role="presentation" />}
						{isError && !withoutIcon && <img src={errorIcon} alt="" role="presentation" />}
						{header}
					</div>
					{children}
					<div className={classes.center}>{button && <Button {...button}>{button.name}</Button>}</div>
				</div>
			</>
		</Dialog>
	);
};

CustomConfirmationDialog.propTypes = {};

export default CustomConfirmationDialog;
